<p-fieldset>
  <p-header class="article-title">
      <span class="article-title">{{ 'TITLE-USER-LOG' | translate }}</span>
      <button class="fab-button primary" appFiltersButton pTooltip="Exibir/Ocultar Filtros" tooltipPosition="left">
          <i class="pi pi-filter"></i>
      </button>
  </p-header>

  <form class="filters" (submit)="find()" appFilters>
      <div class="filter-row">
          <div class="form-control">
              <label>Data inicial</label>
              <p-calendar dateFormat="dd/mm/yy" name="dateStart" [monthNavigator]="true" appendTo="body"
                  [yearNavigator]="true" [yearRange]="'2000:2055'" rPCalendarMask [(ngModel)]="filter.dateStart"
                  [showIcon]="true" i18n>
              </p-calendar>
          </div>
          <div class="form-control">
              <label>Data final</label>
              <p-calendar dateFormat="dd/mm/yy" name="dateEnd" [monthNavigator]="true" [yearNavigator]="true"
                  [yearRange]="'2000:2055'" rPCalendarMask appendTo="body" [(ngModel)]="filter.dateEnd"
                  [showIcon]="true" i18n>
              </p-calendar>
          </div>
          <div class="form-control">
              <label>{{ 'USER' | translate }}</label>
              <p-dropdown placeholder="Selecione..." [filter]="true" [options]="filteredUsers" appendTo="body"
                  [(ngModel)]="filter.userId" name="selectedUserId">
              </p-dropdown>
          </div>

          <div class="buttons">
              <div class="form-button">
                  <button type="submit" class="primary easymarine">{{ 'FIND' | translate }}</button>
              </div>
          </div>
      </div>
  </form>
  <div *ngIf="!userLogs || userLogs.length === 0" class="empty-state" style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px; text-align: center; padding: 2rem;">
      <i class="pi pi-search" style="font-size: 4rem; color: #6c757d; margin-bottom: 1rem;"></i>
      <p style="color: #6c757d; font-size: 1.1rem; margin: 0; max-width: 400px;">Adicione algum filtro, ou apenas clique em Pesquisar para exibir os dados</p>
  </div>
  <app-user-log-table [userLogs]="userLogs" *ngIf="userLogs && userLogs.length > 0"></app-user-log-table>
</p-fieldset>
